module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('齐齐直播'),
      expression: "'齐齐直播'"
    }],
    staticClass: "center"
  }, [_c('navtop'), _vm._v(" "), _c('div', {
    staticClass: "userInfo"
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg || '../../../static/zhubo.jpg'
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "userName"
  }, [(!_vm.fixednick) ? _c('a', [_vm._v(_vm._s(_vm.baseInfo.nick !== 'undefined' ? _vm.baseInfo.nick.slice(0, 8) : '齐齐牛人'))]) : _vm._e(), _vm._v(" "), (_vm.fixednick) ? _c('a', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uNick),
      expression: "uNick"
    }],
    staticClass: "fixednick-inp",
    attrs: {
      "type": "text",
      "placeholder": _vm.baseInfo.nick !== 'undefined' ? _vm.baseInfo.nick.slice(0, 6) : '',
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.uNick)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uNick = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "保存",
      "disabled": _vm.saveNick
    },
    on: {
      "click": _vm.subNick
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": _vm.cancelSubNick
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.fixednick) ? _c('i', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        _vm.fixednick = !_vm.fixednick
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uLabel"
  }, [_c('img', {
    attrs: {
      "src": _vm.leval ? ('https://static.qxiu.com/h5/img/static/nobility/' + (_vm.leval.nobility) + '.png') : ''
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userId"
  }, [_vm._v("ID : " + _vm._s(_vm.baseInfo.uid))])])]), _vm._v(" "), _c('ul', {
    staticClass: "funcList"
  }, [(_vm.showYe) ? _c('li', {
    staticClass: "zhye"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../img/dating/icon-cash.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v("余额:")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toCharge
    }
  }, [_vm._v("充值")]), _vm._v(" "), _c('span', {
    staticClass: "ye"
  }, [_vm._v(_vm._s(_vm.qiqidou))])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mycare",
    on: {
      "click": _vm.toMycare
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../img/dating/icon-care.png")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.isxiaoxiong) ? _c('li', {
    staticClass: "bindPhone",
    on: {
      "click": _vm.toBindPhone
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../img/dating/icon-phone.png")
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "jwdj"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../img/dating/icon-level.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "level"
  }, [_vm._v("等级")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": _vm.leval ? ('https://static.qxiu.com/h5/img/static/nobility/' + (_vm.leval.nobility) + '.png') : ''
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nobWrap"
  }, [_c('b', [_vm._v(_vm._s(_vm.curScore) + "/" + _vm._s(_vm.totalScore))]), _vm._v(" "), _c('i', {
    style: ('width: ' + _vm.curScore / _vm.totalScore * 6.4 + 'rem;')
  })]), _vm._v(" "), _c('p', [(_vm.leval.nobility != 28) ? _c('img', {
    attrs: {
      "src": _vm.leval ? ('https://static.qxiu.com/h5/img/static/nobility/' + (_vm.leval.nobility + 1) + '.png') : ''
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.kefuQQ = true
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../img/dating/icon-connect.png")
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "authCode-item"
  }, [_c('div', {
    staticClass: "authCode-wrap"
  }, [_c('span', {
    staticClass: "authCode-label"
  }, [_vm._v("登陆码")]), _vm._v(" "), _c('div', {
    staticClass: "authCode-scroll"
  }, [_c('span', {
    staticClass: "authCode-text"
  }, [_vm._v(_vm._s(_vm.authCode))])])])]), _vm._v(" "), (_vm.isHideLogout && !_vm.isYouxi) ? _c('li', {
    staticClass: "logout"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../img/dating/icon-logout.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    staticClass: "logout",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出账号")])])]) : _vm._e()]), _vm._v(" "), (_vm.kefuQQ) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v("请联系官方客服QQ:")]), _vm._v(" "), _c('p', [_vm._v("8007777777")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.kefuQQ = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.kefuQQ = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.logoutTips) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v("退出登录")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.confirmLogout
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.logoutTips = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.nickTips) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v(_vm._s(_vm.nickTipsCon))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.nickTips = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        _vm.nickTips = false
      }
    }
  }, [_vm._v("x")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v("我关注的")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v("绑定手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "bgKf"
  }, [_vm._v("联系客服")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a729226","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/center.vue
// module id = 119
// module chunks = 0